import { CONFIG } from "../config";

const hasGa4 = /^G-[A-Z0-9]+$/i.test((CONFIG.gaId || "").trim());
const hasMetaPixel = /^\d+$/.test((CONFIG.metaPixelId || "").trim());

let ga4Ready = false;
let metaReady = false;

const loadScript = (id, src) =>
  new Promise((resolve, reject) => {
    if (document.getElementById(id)) return resolve();
    const script = document.createElement("script");
    script.id = id;
    script.async = true;
    script.src = src;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });

export async function initAnalytics() {
  if (hasGa4 && !ga4Ready) {
    window.dataLayer = window.dataLayer || [];
    window.gtag =
      window.gtag ||
      function gtag() {
        window.dataLayer.push(arguments);
      };
    window.gtag("js", new Date());
    window.gtag("config", CONFIG.gaId.trim(), { send_page_view: false });
    try {
      await loadScript("ga4-script", `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(CONFIG.gaId.trim())}`);
      ga4Ready = true;
    } catch {
      /* analytics is best-effort */
    }
  }

  if (hasMetaPixel && !metaReady) {
    window.fbq =
      window.fbq ||
      function fbq() {
        window.fbq.callMethod ? window.fbq.callMethod.apply(window.fbq, arguments) : window.fbq.queue.push(arguments);
      };
    if (!window._fbq) window._fbq = window.fbq;
    window.fbq.push = window.fbq;
    window.fbq.loaded = true;
    window.fbq.version = "2.0";
    window.fbq.queue = window.fbq.queue || [];
    window.fbq("init", CONFIG.metaPixelId.trim());
    try {
      await loadScript("meta-pixel-script", "https://connect.facebook.net/en_US/fbevents.js");
      metaReady = true;
    } catch {
      /* analytics is best-effort */
    }
  }
}

export function trackPageView() {
  const page = { page_title: document.title, page_location: window.location.href };
  if (hasGa4 && window.gtag) window.gtag("event", "page_view", page);
  if (hasMetaPixel && window.fbq) window.fbq("track", "PageView", page);
}

export function trackEvent(name, params = {}) {
  const safeParams = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null));
  if (hasGa4 && window.gtag) window.gtag("event", name, safeParams);
  if (hasMetaPixel && window.fbq) window.fbq("trackCustom", name, safeParams);
}
